<template>
    <div class="return-page return-success-page">
        <div class="page-content">
            <div class="return-header-wrapper">
                <div class="return-header">
                    <h2>Rothco Return Form Confirmation</h2>
                    <p>Your return is currently being processed. Please remember to include the Return Form in your return shipment to Rothco. Thank you.</p>
                </div>
                <div class="return-summary">
                    <p>Return No: {{returnInfo.return_id}}</p>
                    <p>Status: {{returnInfo.status}}</p>
                    <p>Comments: {{returnInfo.comment}}</p>
                </div>
            </div>
            <div  class="items-available-to-return" id="tableContainer">
                <div class="title-container">
                    <div class="title-l">Returned Items</div>
                    <div class="content text-rothcoText">
                        <div class="paragraph-default">{{ totalItems }} Items</div>
                    </div>
                </div>

                <return-items-table v-model="items" :availableReturnReasons="returnReasons" :isReturnSuccess="true" :checkable="false" />
            </div>

            <return-amount-summary :returnAmount="returnCost" />    
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, toRefs, ref} from "vue";
    import { Link } from "@inertiajs/vue3";
    import ReturnItemsTable from "@/components/ReturnItemsTable.vue";
    import ReturnAmountSummary from "@/components/ReturnAmountSummary.vue";
    import { comingSoonImages } from "@/helpers/composables/comingSoonImages"
     
    const props = defineProps({
        returnInfo: {
            type: Object,
        },
        returnReasons: {
            type: Array,
            default: []
        },
        couponAdjustAmount: {
            type: Number,
            default: 0
        }
    });
    let { returnInfo, returnReasons, couponAdjustAmount } = toRefs(props);

    let items = computed(() => {
        return [...returnInfo.value.return_items.map((item) => {
                const variation = item.order_item.item_variation;
                return {
                    return_item_id: item.return_item_id,
                    quantity: item.quantity,
                    return_reason_id: item.return_reason_id,
                    return_quantity: item.quantity,
                    item_name: variation.item?.name,
                    item_no: variation.rothcoItem?.rothco_item_no,
                    price: item.order_item.price,
                    variants_text: Object.entries(variation?.text_description ?? {})
                                .map(([key, value]) => `${key}: ${value}`)
                                .join(' - '),
                    variants_badges: variation.text_description,
                    seo_name: variation.item?.seo_name,
                    image: variation.primary_image?.image_filename ? `${import.meta.env.VITE_APP_URL}/upload/product/product/small/${variation.primary_image?.image_filename}`
                        : comingSoonImages().small
                };
            })
        ];
    });

    const totalItems = computed(()=> {
        return items.value.reduce((total, item) => {
            return total + item.quantity;
        }, 0);
    });

    const returnCost = ref({
        subtotal: returnInfo.value.amount,
        couponAdjust: couponAdjustAmount.value,
        tax: returnInfo.value.tax,
        amount: returnInfo.value.amount_with_tax - couponAdjustAmount.value
    });
</script>
